import { IconTooltip } from 'sonata-react-components';

import './sectionHeader.scss';

type Props = {
  /** Ordinal shown in the badge, e.g. "01". */
  number: string;
  title: string;
  description: string;
  /** Rendered as an info tooltip beside the title when provided. */
  tooltip?: string;
};

/**
 * Numbered heading shared by the DOOH report sections: an ordinal badge, the
 * section title and an optional info tooltip.
 */
export default function SectionHeader({ number, title, description, tooltip }: Readonly<Props>) {
  return (
    <header className="sectionHeader">
      <span className="sectionHeader__number">{number}</span>
      <h2 className="sectionHeader__title">
        {title}
        <span className="sectionHeader__description"> {description}</span>
      </h2>
      {tooltip && (
        <IconTooltip
          icon="fa-regular fa-circle-info"
          iconColor="var(--color-sonata-primary-500, #7B9FE1) !important"
          place="top"
        >
          {tooltip}
        </IconTooltip>
      )}
    </header>
  );
}
